import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'

import LABELESPECIAL from '../../business-const/Label/LabelEspecial'

const comparacaoCenariosEstudosItemList = [
    {
        id: HARDCODE.comparacaoCenariosEstudosIdadeDataSimulacaoCliente,
        descricao: 'Idade Data Simulação',
        grupo: 'PAR',
        decimais: 0,
        //formataSemMoeda: true,
        complemento: LABELESPECIAL.anos,
        ordem: 110,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosIdadeVaiAposentarCliente,
        descricao: 'Idade vai Aposentar',
        grupo: 'PAR',
        decimais: 0,
        //formataSemMoeda: true,
        complemento: LABELESPECIAL.anos,
        ordem: 120,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosIdadeFinalVitalicioClienteConjuge,
        descricao: LABEL.idadeExpectativaVida,
        grupo: 'PAR',
        decimais: 0,
        //formataSemMoeda: true,
        complemento: LABELESPECIAL.anos,
        ordem: 125,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosRetornoReal,
        descricao: 'Retorno Real',
        grupo: 'PAR',
        decimais: 2,
        //formataSemMoeda: true,
        complemento: LABEL.perc,
        ordem: 130,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosProjetosVidaSonho,
        descricao: '',
        grupo: 'PVS',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 210,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria,
        descricao: '',
        grupo: 'NAP',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 310,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosAporteEconomiaReceitaMensal,
        descricao: '% Economia Receita Mensal',
        grupo: 'APT',
        decimais: 2,
        //formataSemMoeda: true,
        ordem: 410,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria,
        descricao: '',
        grupo: 'APT',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 420,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosValorPresenteReservaInicioAposentadoria,
        descricao: 'Reserva Início ' + LABEL.aposentadoria,
        grupo: 'APO',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 510,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosValorPresenteNecessidadesInicioAposentadoria,
        descricao: 'Necessidades Início ' + LABEL.aposentadoria,
        grupo: 'APO',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 520,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosSuperavitDeficitAposentadoria,
        descricao: 'Superávit / (-)Déficit Início ' + LABEL.aposentadoria,
        grupo: 'APO',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 530,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosRecursosFinanceirosAcumuladosAposentadoriaIdadeAte,
        descricao: LABEL.idadeLimiteReservaAposentadoria,
        grupo: 'APO',
        decimais: 0,
        //formataSemMoeda: true,
        complemento: LABELESPECIAL.anos,
        ordem: 540,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosRecursosFinanceirosIdadeFinalVitalicioClienteConjuge,
        descricao: 'Recursos Financeiros Expectativa de Vida',
        grupo: 'APO',
        decimais: 0,
        //formataSemMoeda: true,
        ordem: 545,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosRetiradaMensalMaximaConsumirReservaAposentadoria,
        descricao: 'Retirada mensal máxima: Consumir reserva',
        grupo: 'APO',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 550,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosRetiradaMensalMaximaPreservarReservaAposentadoria,
        descricao: 'Retirada mensal máxima: Preservar reserva',
        grupo: 'APO',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 560,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosAporteMensalConsumirReservaAposentadoria,
        descricao: 'Aporte mensal: Manter padrão e Consumir reserva',
        grupo: 'APO',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 570,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosAporteMensalPreservarReservaAposentadoria,
        descricao: 'Aporte mensal: Manter padrão e Preservar reserva',
        grupo: 'APO',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 580,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosAporteUnicoConsumirReservaAposentadoria,
        descricao: 'Aporte único: Manter padrão e Consumir reserva',
        grupo: 'APO',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 590,
    },
    {
        id: HARDCODE.comparacaoCenariosEstudosAporteUnicoPreservarReservaAposentadoria,
        descricao: 'Aporte Único: Manter padrão e Preservar reserva',
        grupo: 'APO',
        decimais: 2,
        //formataSemMoeda: false,
        ordem: 600,
    },
]

export default comparacaoCenariosEstudosItemList